import { createApiCall } from 'lib/base';

// "id" maps to the ICB code string (e.g. "8355") in the URL param
const makeEditCall = (key: string, path: string) =>
  createApiCall<{ id: string; payload: any }>(
    key,
    ({ id, payload }) => ({
      endpoint: `api/admin/${path}/${id}`,
      method: 'PATCH',
      body: payload,
    })
  );

export const editIndustry = makeEditCall(
  'EDIT_ICB_INDUSTRY',
  'stock-icb/industries'
);
export const editSuperSector = makeEditCall(
  'EDIT_ICB_SUPERSECTOR',
  'stock-icb/supersectors'
);
export const editSector = makeEditCall(
  'EDIT_ICB_SECTOR',
  'stock-icb/sectors'
);
export const editSubSector = makeEditCall(
  'EDIT_ICB_SUBSECTOR',
  'stock-icb/subsectors'
);
